import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DomSanitizer } from '@angular/platform-browser';
import moment from 'moment';
import { NewServiceItemModalComponent } from '../new-service-item-modal/new-service-item-modal.component';
import { EmployeeInfoService } from '../../../core/services/employee-info.service';
import { PortalSettingsService } from '../../../core/services/portal-settings.service';
import { SmService } from '../../../pages/sm/services/sm.service';
import { SmDataService } from '../../../pages/sm/services/sm-data.service';

@Component({
  selector: 'app-service-list-modal',
  templateUrl: './service-list-modal.component.html',
  styleUrls: ['./service-list-modal.component.css'],
})
export class ServiceListModalComponent implements OnInit {
  @Input() WOorSI: any;
  @Input() woData: any;
  @Input() lookupList: any;
  @Input() format: any;
  formData: { [key: string]: any };
  serviceList: any;
  woHistoryList: any;
  filteredServiceList: any;
  portalSettings: any;
  employeeInfo: any;
  datepickerOptions: any;
  datePickerOptionsMonth: any;
  dateFormat: string;
  SMEditServiceSiteNote: any;
  SMAllowServiceItemEdit: any;

  constructor(
    private ngbModalService: NgbModal,
    private smService: SmService,
    private ngbActiveModal: NgbActiveModal,
    private sanitizer: DomSanitizer,
    private portalSettingsService: PortalSettingsService,
    private employeeInfoService: EmployeeInfoService,
    public smDataService: SmDataService
  ) {
    this.portalSettings = this.portalSettingsService.getPortalSettings();
    this.employeeInfo = employeeInfoService.getEmployeeInfo();
  }

  ngOnInit() {
    this.formData = {
      searchText: null,
      onEdit: this.woData.ServiceSiteNotes == null && this.SMEditServiceSiteNote ? true : false,
    };
    this.SMAllowServiceItemEdit = this.employeeInfo.SMAllowServiceItemEdit;
    this.SMEditServiceSiteNote = this.portalSettings.SMEditServiceSiteNote.ConfigValue == '1';
    if (this.WOorSI == 'WO') {
      this.getWorkOrderHistory();
    } else {
      this.getServiceItemDetails();
    }
  }

  getServiceItemDetails() {
    this.smService.getServiceItemDetails(this.woData.SMServiceSiteID, null).then(response => {
      this.serviceList = response;
      this.serviceList.forEach(service => {
        if (service.SMTypeID != null) service.SMTypeID = service.SMTypeID.toString();
        if (service.Description != null) service.DescriptionHTML = service.Description;
      });
      this.filterServiceItem();
    });
  }

  getWorkOrderHistory() {
    this.smService.serviceItemWOHistory(this.woData.SMServiceSiteID, this.woData.SMTripID, null).then(response => {
      this.woHistoryList = response;
      this.woHistoryList.forEach(woHistory => {
        if (woHistory.CompletedDate != null)
          woHistory.CompletedDateDisplay = moment(woHistory.CompletedDate).utc().format(this.format.toUpperCase());
        if (woHistory.TripNotes != null && woHistory.TripNotes != '') woHistory.TripNotesHTML = woHistory.TripNotes;
        else {
          woHistory.TripNotesHTML = null;
        }
      });
    });
  }

  editNotes() {
    this.formData.onEdit = !this.formData.onEdit;
  }

  saveNotes() {
    this.woData.ServiceSiteNotes =
      this.woData.ServiceSiteNotes != null && this.woData.ServiceSiteNotes != ''
        ? this.woData.ServiceSiteNotes.split('\n').join('\r\n')
        : '';
    this.smService.updateSiteNotes(this.woData.SMServiceSiteID, this.woData.ServiceSiteNotes).then(response => {
      this.editNotes();
    });
  }

  routeToServiceDetail(data) {
    this.ngbActiveModal.close({ data: data, where: 'Service' });
  }

  toDrillDown(data) {
    this.ngbActiveModal.close({ data: data, where: 'Work' });
  }

  closeModal() {
    this.ngbActiveModal.close();
  }

  filterServiceItem() {
    setTimeout(() => {
      this.filteredServiceList = [];
      this.serviceList.forEach(service => {
        if (this.formData.searchText != null && this.formData.searchText != '') {
          if (
            (service.Model != null ? service.Model.toLowerCase().indexOf(this.formData.searchText.toLowerCase()) > -1 : false) ||
            (service.SerialNumber != null
              ? service.SerialNumber.toLowerCase().indexOf(this.formData.searchText.toLowerCase()) > -1
              : false) ||
            (service.DescriptionHTML != null
              ? service.DescriptionHTML.toString().toLowerCase().indexOf(this.formData.searchText.toLowerCase()) > -1
              : false) ||
            (service.ServiceItem != null ? service.ServiceItem.toLowerCase().indexOf(this.formData.searchText.toLowerCase()) > -1 : false)
          ) {
            this.filteredServiceList.push(service);
          }
        } else {
          this.filteredServiceList.push(service);
        }
      });
    });
  }

  createServiceItem() {
    const modalRef = this.ngbModalService.open(NewServiceItemModalComponent, { size: 'lg', backdrop: 'static' });
    modalRef.componentInstance.lookupList = this.lookupList;
    modalRef.componentInstance.woData = this.woData;
    modalRef.result.then(response => {
      this.getServiceItemDetails();
    });
  }
}
